goog.provide("shadow.js.shim.module$$jupyterlab$cells");
goog.provide("module$shadow_js_shim_module$$jupyterlab$cells");
shadow.js.shim.module$$jupyterlab$cells = require("@jupyterlab/cells");
module$shadow_js_shim_module$$jupyterlab$cells.default = shadow.js.shim.module$$jupyterlab$cells;
